<template lang="pug">
    .advanced-landing
        div(v-html="html")
        link( rel="stylesheet" :href="config.advanced_configuration.css" )
        mounting-portal(v-if="hasRegistrationButton" mountTo=".registration-button-container" name="source")
            registration-card(:config="config" :session="session")
</template>
<script>
import { MountingPortal } from 'portal-vue';
import RegistrationCard from '@/components/registration/RegistrationCard.vue';

export default {
    name: 'AdvancedLanding',

    components: {
        MountingPortal,
        RegistrationCard
    },

    props: {
        config: {
            type: Object,
            required: true
        },

        session: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            hasRegistrationButton: false,
            html: ''
        };
    },

    async created() {
        if (this.config.advanced_configuration.body) {
            const { data } = await this.$services.publicLogin.get(this.config.advanced_configuration.body);
            this.html = data;
            if (data.includes('class="registration-button-container"')) {
                this.hasRegistrationButton = true;
            }
        }
    },

    mounted() {
        let jsScript = document.createElement('script');
        jsScript.setAttribute('src', this.config.advanced_configuration.js);
        document.head.appendChild(jsScript);
    }
}

</script>
